import { isEmpty } from 'lodash';

// => Remove special character
export const removeSpclChar = (string) => {
    let newString = string;
    if (!isEmpty(string)) {
        newString = string.replace(/[^a-zA-Z ]/g, ' ');
    }
    return newString;
};

const strHelper = () => {
    const strCapitalizeFirstChar = (string) => {
        let capitalizedStr =
            string.charAt(0).toUpperCase() + string.substring(1);
        return capitalizedStr;
    };
    return {
        strCapitalizeFirstChar,
    };
};

export default strHelper;
